export default  {
  search_text: 'Please input your text',
  food_list: 'Catering list',
  '搜索':'search',
  '商品清单空空的~':'empty',
  '件商品':'piece',
  '收起':'Retract',
  '展开':'Open',
  '删除':'delete',
  '总计':'summary',
  '去结算':'Settlement',
  '库存不足':'Shortage of stock, please reduce the quantity of purchases',
  '商品已变更,请重新购买': 'The goods have been changed, please buy again'
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/foodList.js